import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Role, RoleValues } from '@api/types';
import { ProfileService } from '../../shared/services/profile.service';
import { map, take } from 'rxjs/operators';

@Injectable()
export class AuthService {
  private LoggedIn: any = false;
  private redirectUrl: string;

  constructor(private profileService: ProfileService) {}

  isLoggedIn(forceFetch?: boolean): Observable<boolean> {
    return this.profileService.whoAmI(forceFetch).pipe(
      map(
        user => {
          return !!(user && user.role !== RoleValues.ANONYMOUS && user.role !== RoleValues.NO_PROFILE);
        },
        err => {
          return false;
        }
      ),
      take(1)
    );
  }

  getRedirectUrl(): string {
    return this.redirectUrl;
  }

  setRedirectUrl(url: string) {
    this.redirectUrl = url;
  }
}
